import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment';

import {
  FertilizationLegalStandards,
  GenerateFertilizationLegalStandardsRequest,
} from '../models/legal-standard.model';

@Injectable({
  providedIn: 'root',
})
export class FertilizationLegalStandardsApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.USE_ARABLE_SERVICE_FIELD_REPORT_ROUTES
    ? `${this.env.APIM_BASE_URL}/arable-service/advice/fertilization-legal-standard`
    : `${this.env.API_BASE_URL}/service/field-report/secure/fertilizationlegalstandard`;

  getFertilizationLegalStandards(
    request: GenerateFertilizationLegalStandardsRequest,
  ): Observable<FertilizationLegalStandards> {
    return this.http.post<FertilizationLegalStandards>(this.baseUrl, request);
  }
}
